export const URL_PARAMETRES_ENTITES =
	'/api/finances/comptabilite/parametrescomptabilites/entites/';
export default URL_PARAMETRES_ENTITES;
